<button
    type="{{type}}"
    [attr.aria-label]="ariaLabel"
    [class.disabled]="disabled"
    [class.loading]="loaderShow"
    [disabled]="disabled || loaderShow"
    [style.border-width.px]="borderWidth"
    [style.flex-direction]="iconPosition === 'right' ? 'row-reverse' : 'row'"
    [ngClass]="[
        !!bgColor ? 'bgColor-' + bgColor : '',
        !!textColor ? 'textColor-' + textColor : '',
        !!hoverColor ? 'hoverColor-' + hoverColor : '',
        !!text ? 'text' : '',
        !!borderWidth ? 'border' : '',
        !!justIcon ? 'justIcon' : ''
    ]"
>
    <i *ngIf="iconName" class="iconsax" [ngClass]="[!!iconColor ? 'iconColor-' + iconColor : '']" [iconName]="iconName"></i>
    <span *ngIf="text && !textArguments" class="textx">{{ text | translate }}</span>
    <span *ngIf="text && textArguments" class="textx">{{ text | translate: textArguments }}</span>
    <span
        *ngIf="loaderShow"
        [ngClass]="bgColor"
        [class.bgColor-transparent]="!bgColor"
        class="loaderx iconsax"
        iconName="refresh"></span>
</button>

<div *ngIf="tooltipText" class="ui-tooltip" [ngClass]="tooltipPosition">
    <ng-container *ngIf="tooltipIsHtml; else normalTooltip">
        <div [innerHTML]="tooltipText"></div>
    </ng-container>
    <ng-template #normalTooltip>{{tooltipText | translate }}</ng-template>
</div>
